var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_204_165)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_204_165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 40.0769V7.92308C5 7.14783 5.30797 6.40433 5.85615 5.85615C6.40433 5.30797 7.14783 5 7.92308 5H40.0769C40.8522 5 41.5957 5.30797 42.1438 5.85615C42.692 6.40433 43 7.14783 43 7.92308V40.0769C43 40.8522 42.692 41.5957 42.1438 42.1438C41.5957 42.692 40.8522 43 40.0769 43H31.3077V29.1446H33.3831C33.856 29.1446 34.3095 28.9568 34.6439 28.6224C34.9783 28.288 35.1662 27.8344 35.1662 27.3615V25.1108C35.1654 24.6381 34.9773 24.185 34.643 23.8508C34.3088 23.5166 33.8557 23.3285 33.3831 23.3277H31.4246V20.58C31.4246 18.1246 32.5354 18.1246 33.6462 18.1246H35.0785C35.3137 18.1343 35.5482 18.0922 35.7654 18.0013C35.9826 17.9104 36.1772 17.7729 36.3354 17.5985C36.5053 17.4367 36.6397 17.2415 36.7303 17.0252C36.8209 16.8088 36.8655 16.576 36.8615 16.3415V14.1785C36.8701 13.9402 36.8315 13.7027 36.7478 13.4795C36.6642 13.2563 36.5372 13.0518 36.3741 12.8779C36.2111 12.704 36.0153 12.5641 35.7979 12.4662C35.5805 12.3684 35.346 12.3145 35.1077 12.3077H31.7462C30.7653 12.2708 29.7881 12.4473 28.8822 12.825C27.9762 13.2026 27.163 13.7724 26.4987 14.495C25.8345 15.2177 25.335 16.0759 25.0348 17.0104C24.7346 17.9449 24.6408 18.9334 24.76 19.9077V23.3277H22.8892C22.6526 23.3238 22.4176 23.3671 22.1979 23.4549C21.9782 23.5428 21.7781 23.6735 21.6095 23.8395C21.4408 24.0055 21.3068 24.2033 21.2154 24.4216C21.124 24.6399 21.0769 24.8741 21.0769 25.1108V27.3615C21.0769 27.5982 21.124 27.8325 21.2154 28.0507C21.3068 28.269 21.4408 28.4669 21.6095 28.6328C21.7781 28.7988 21.9782 28.9295 22.1979 29.0174C22.4176 29.1052 22.6526 29.1485 22.8892 29.1446H24.76V43H7.92308C7.14783 43 6.40433 42.692 5.85615 42.1438C5.30797 41.5957 5 40.8522 5 40.0769Z",
    stroke: "#FF9117",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5 40.0769V7.92308C5 7.14783 5.30797 6.40433 5.85615 5.85615C6.40433 5.30797 7.14783 5 7.92308 5H40.0769C40.8522 5 41.5957 5.30797 42.1438 5.85615C42.692 6.40433 43 7.14783 43 7.92308V40.0769C43 40.8522 42.692 41.5957 42.1438 42.1438C41.5957 42.692 40.8522 43 40.0769 43H31.3077V29.1446H33.3831C33.856 29.1446 34.3095 28.9568 34.6439 28.6224C34.9783 28.288 35.1662 27.8344 35.1662 27.3615V25.1108C35.1654 24.6381 34.9773 24.185 34.643 23.8508C34.3088 23.5166 33.8557 23.3285 33.3831 23.3277H31.4246V20.58C31.4246 18.1246 32.5354 18.1246 33.6462 18.1246H35.0785C35.3137 18.1343 35.5482 18.0922 35.7654 18.0013C35.9826 17.9104 36.1772 17.7729 36.3354 17.5985C36.5053 17.4367 36.6397 17.2415 36.7303 17.0252C36.8209 16.8088 36.8655 16.576 36.8615 16.3415V14.1785C36.8701 13.9402 36.8315 13.7027 36.7478 13.4795C36.6642 13.2563 36.5372 13.0518 36.3741 12.8779C36.2111 12.704 36.0153 12.5641 35.7979 12.4662C35.5805 12.3684 35.346 12.3145 35.1077 12.3077H31.7462C30.7653 12.2708 29.7881 12.4473 28.8822 12.825C27.9762 13.2026 27.163 13.7724 26.4987 14.495C25.8345 15.2177 25.335 16.0759 25.0348 17.0104C24.7346 17.9449 24.6408 18.9334 24.76 19.9077V23.3277H22.8892C22.6526 23.3238 22.4176 23.3671 22.1979 23.4549C21.9782 23.5428 21.7781 23.6735 21.6095 23.8395C21.4408 24.0055 21.3068 24.2033 21.2154 24.4216C21.124 24.6399 21.0769 24.8741 21.0769 25.1108V27.3615C21.0769 27.5982 21.124 27.8325 21.2154 28.0507C21.3068 28.269 21.4408 28.4668 21.6095 28.6328C21.7781 28.7988 21.9782 28.9295 22.1979 29.0174C22.4176 29.1052 22.6526 29.1485 22.8892 29.1446H24.76V43H7.92308C7.14783 43 6.40433 42.692 5.85615 42.1438C5.30797 41.5957 5 40.8522 5 40.0769Z",
    stroke: "#FFDF22",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_204_165",
    x: -2.55,
    y: -2.55,
    width: 53.1,
    height: 53.1,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.568627 0 0 0 0 0.0901961 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_204_165"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_204_165",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_204_165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/FB.319ae6d688f59592b3627e8fed8c999b.svg";
export { ForwardRef as ReactComponent };